<template>
    <div>
        <div class="card rounded-bottom-0 mt-3">
            <div class="card-header">
                 <h3>
                    {{ isEditView ? $t("headers.vehicleEntryEdit") : $t("headers.vehicleEntryAdd") }}
                 </h3>
            </div>
            <div class="card-body pb-0">
                <div class="p-2">
                    <VehicleEntryForm ref="vehicleForm" :vehicle="vehicle" />
                </div>
            </div>

        </div>
        <div class="card mx-0 mb-3 mt-0 rounded-top-0">
            <div class="card-header rounded-top-0">
                <h4>{{ $t("headers.commodity") }}</h4>
            </div>
            <div class="card-body">
                <div v-if="commoditiesData.length === 0">
                    <h3 class="text-danger fw-bold">{{ $t("commodity.warning") }}</h3>
                </div>
                <div v-for="commodity in commoditiesData" :key="commodity.formId" class="mb-3 border-bottom pb-3">
                    <div class="d-flex align-items-end ">
                        <CommodityForm :ref="'commodityForm' + commodity.formId" :commodity="commodity"/>
                        <button class="btn btn-danger btn-sm ms-3 px-3 py-2 d-flex flex-row justify-content-center align-items-center" @click="removeCommodityForm(commodity.formId)">
                            <span class="fs-6 text-white fw-bold">{{ $t("utils.remove") }}</span>
                        </button>
                    </div>
                </div>
                <div class="text-start mt-3">
                    <button
                        class="btn btn-primary btn-sm px-3 py-2 d-flex flex-row justify-content-center align-items-center"
                        @click="addCommodityForm"
                    >
                        <icon icon="Plus" class="user_icon"></icon>
                        <span class="ms-2 fs-6 text-white fw-bold">{{ $t("utils.addAnother") }}</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import VehicleEntryForm from '@/components/VehicleEntryForm.vue';
    import CommodityForm from '@/components/CommodityForm.vue';
    import Icon from '@/components/Icon.vue'
    import { formatForBackend } from '@/utils/date';

    export default {
        components: {
            VehicleEntryForm,
            CommodityForm,
            Icon,
        },
        props: {
            vehicle: {
                type: Object,
                default: () => ({})
            },
            commodities: {
                type: Array,
                default: () => [],
            }
        },
        data() {
            return {
                commoditiesData: [],
                nextCommodityId: 1,
            }
        },
        methods: {
            addCommodityForm() {
                this.commoditiesData.push({
                    formId: this.nextCommodityId++,
                    id: null,
                    name: "",
                    quantity: "",
                    unit: null,
                    note: ""
                })
            },
            removeCommodityForm(formId) {
                this.commoditiesData = this.commoditiesData.filter(c => c.formId !== formId);
            },
            initializeCommodities(commodities) {
                this.commoditiesData = (commodities || []).map((c, index) => ({
                    formId: index + 1,
                    id: c.id ?? null,
                    name: c.name ?? "",
                    quantity: c.quantity ?? "",
                    unit: c.unit ?? null,
                    note: c.note ?? "",
                }));
                this.nextCommodityId = this.commoditiesData.length + 1;
            },
            collectFormData() {
                const vehicleForm = this.$refs.vehicleForm;
                if (!vehicleForm.validateData()) return;

                const vehicleData = vehicleForm.localVehicle || {};

                const commodities = []

                for (let form of this.commoditiesData) {
                    const commodityForm = this.$refs["commodityForm" + form.formId];
                    if (!commodityForm) continue;

                    const finalForm = Array.isArray(commodityForm) ? commodityForm[0] : commodityForm;
                    if (!finalForm.validateData()) return;

                    const commodityData = finalForm.localCommodity || {};

                    if (commodityData.name) {
                        const data = {
                            name: commodityData.name,
                            quantity: commodityData.quantity,
                            unit: commodityData.unit,
                            note: commodityData.note,
                        }

                        if (commodityData.id !== undefined && commodityData.id !== null) {
                            data.id = commodityData.id;
                        }
                        commodities.push(data)
                    }
                }

                return {
                    vehicle: {
                        carrier: vehicleData.carrier,
                        driverName: vehicleData.driverName,
                        licencePlate: vehicleData.licencePlate,
                        expectedFrom: formatForBackend(vehicleData.expectedFrom),
                        expectedTo: formatForBackend(vehicleData.expectedTo),
                        status: vehicleData.status,
                        note: vehicleData.note,
                        commodities: commodities,
                    },
                    commodities,
                };
            }
        },
        watch: {
            commodities: {
                handler(newVal) {
                    if (newVal.length > 0) {
                        this.initializeCommodities(newVal);
                    }
                },
                immediate: true
            }
        },
        computed: {
            isEditView() {
                return this.$route.name === "vehicleEntryEditView"
            }
        }
    }
</script>